@if (spinner) {
<app-spinner></app-spinner>
}
<div class="inner-page-header" #goUp>
  <h3>قائمة خدمات سوپرا</h3>
</div>
<div class="request-control">
  <div class="right-side">
    @if (filterData) {
    <app-filter [filterData]="filterData" [filterDataInit]="filterDataInit" [filterPage]="filterPage"
      (formValus)="filterFormValues($event)">
    </app-filter>
    }
    <quick-search placeholder=" البحث باسم الخدمة ... " (searchResults)="quickSearch($event)"></quick-search>
  </div>

  <div class="left-side">
    <div class="orders-managment">
      <a routerLink="/pages/sopra/service/add" class="btn btn-green">
        إضافة خدمة جديدة
      </a>
    </div>
  </div>
</div>
<div class="saved-filters">
  <saved-filters></saved-filters>
</div>

<div class="request-table">
  @if (sopraServices && sopraServices.length == 0) {
  <div class="py-5 d-flex justify-content-center align-items-center">
    <p>لم يتم العثور على أي بيانات</p>
  </div>
  } @else {
  <div class="table-responsive">
    <table id="company-table" aria-label="" class="table">
      <thead>
        <tr>
          <th>اسم الخدمة </th>
          <th>عدد الملفات المطلوبة</th>
          <th>عدد مقدمي الخدمة</th>
          <th>الباقات المرتبطة</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for ( service of sopraServices | paginate : config; track service.id; let i = $index) {
        <tr>
          <td>
            {{ service.name }}
          </td>
          <td>
            {{ service.files_count }}
          </td>
          <td>
            <a [routerLink]="'/pages/sopra/sopra-profile'" [queryParams]="{ classifications: service.id }" target="_blank"
              (click)="$event.stopPropagation()">
              {{ service.experts_count }}
            </a>
          </td>
          <td>
            <a [routerLink]="'/pages/services/list/sopra'" [queryParams]="{ classifications: service.id }" target="_blank"
              (click)="$event.stopPropagation()">
              {{service.services_count}}
            </a>
          </td>
          <td>
            <a [routerLink]="'/pages/sopra/service/' + service.id" class="btn btn-custom" (click)="$event.stopPropagation()">
              تعديل الخدمة
            </a>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>

<!-- pagination -->
@if (sopraServices && sopraServices.length > 0) {
<ayen-pagination (pageData)="pageChanged($event)" (pageSize)="pageSizeChanged($event)" [totalCount]="config.totalItems"
  [itemsPerPage]="config.itemsPerPage" (pageChange)="changeToSpecific($event)" [currentPage]="config.currentPage">
</ayen-pagination>
}
